import { FC, SVGAttributes } from "react";

const ApplePayIconBackground: FC<SVGAttributes<SVGSVGElement>> = ({
  width = 32,
  height = 24,
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 32 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Apple Pay</title>
    <rect
      x="0.5"
      y="1.41345"
      width="31"
      height="23"
      rx="3.5"
      fill="white"
      stroke="#EEEEEE"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.79238 8.55164C9.84079 9.01585 9.65723 9.47013 9.38673 9.80845C9.1065 10.1373 8.66242 10.398 8.21793 10.3595C8.15998 9.9147 8.3823 9.44141 8.63348 9.15146C8.91323 8.81286 9.39641 8.57134 9.79238 8.55164ZM8.74913 10.6773C9.03785 10.5635 9.3947 10.4229 9.78733 10.4463C10.0378 10.4657 10.7603 10.5428 11.2228 11.2267C11.2205 11.2285 11.2153 11.2318 11.2078 11.2368C11.089 11.3145 10.3659 11.7877 10.3751 12.7208C10.3841 13.8326 11.291 14.2495 11.4118 14.305C11.4198 14.3087 11.4243 14.3107 11.4249 14.3113C11.4244 14.3129 11.4235 14.3157 11.4222 14.3199C11.3987 14.3956 11.2419 14.8992 10.8857 15.4198C10.5581 15.9019 10.2209 16.3742 9.68137 16.3838C9.42744 16.3885 9.25612 16.3151 9.07784 16.2387C8.89087 16.1586 8.69626 16.0753 8.39069 16.0753C8.07017 16.0753 7.86618 16.1613 7.67003 16.2441C7.50059 16.3155 7.33701 16.3845 7.10924 16.3935C6.58909 16.4125 6.19435 15.8822 5.86679 15.4005C5.19231 14.4268 4.68175 12.6536 5.37534 11.4581C5.71258 10.8605 6.32917 10.4848 6.99369 10.475C7.28381 10.4697 7.5615 10.5795 7.80379 10.6752C7.98789 10.748 8.15156 10.8126 8.28472 10.8126C8.40549 10.8126 8.56318 10.7505 8.74913 10.6773Z"
      fill="black"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.2237 9.10339C17.6267 9.10339 18.6038 10.0705 18.6038 11.4785C18.6038 12.8916 17.6067 13.8637 16.1887 13.8637H14.6353V16.3339H13.5129V9.10339H16.2237ZM14.6353 12.9216H15.9231C16.9002 12.9216 17.4563 12.3955 17.4563 11.4835C17.4563 10.5716 16.9002 10.0505 15.9281 10.0505H14.6353V12.9216ZM20.8915 13.2975C19.5888 13.3776 18.8822 13.9088 18.8822 14.8358C18.8822 15.7677 19.6087 16.389 20.6509 16.389C21.3575 16.389 22.0089 16.0333 22.3046 15.4672H22.3296V16.3339H23.3668V12.7362C23.3668 11.694 22.53 11.0226 21.2473 11.0226C20.0547 11.0226 19.1729 11.704 19.1427 12.641H20.1549C20.2401 12.1951 20.6509 11.9045 21.2172 11.9045C21.9036 11.9045 22.2895 12.2251 22.2895 12.8114V13.2122L20.8915 13.2975ZM22.2895 14.3698V13.9638L21.0418 14.0441C20.3403 14.0891 19.9746 14.3497 19.9746 14.8057C19.9746 15.2466 20.3554 15.5323 20.9516 15.5323C21.7132 15.5323 22.2895 15.0461 22.2895 14.3698ZM24.3204 17.4013V18.2681C24.3955 18.2882 24.6711 18.2983 24.7563 18.2983C25.8487 18.2983 26.3648 17.8823 26.8157 16.6146L28.785 11.0877H27.6425L26.3196 15.3568H26.2946L24.9717 11.0877H23.7993L25.6984 16.349L25.5981 16.6697C25.4277 17.2109 25.1472 17.4213 24.651 17.4213C24.5609 17.4213 24.3906 17.4112 24.3204 17.4013Z"
      fill="black"
    />
  </svg>
);

export default ApplePayIconBackground;
